import type { QueryClient } from '@tanstack/react-query';
import {
  getGetTicketsForTravellerQueryKey,
  getGetTicketsForUserOrganizationQueryKey,
  type IssuedTicketBobcatDataMapDTO,
  type IssuedTicketFindResultDTO,
} from '@/api/trafikportalen';

const REVOKED_TICKET_STATES = new Set<IssuedTicketFindResultDTO['state']>([
  'revoked',
  'marked_for_deletion',
]);

export const invalidateIssuedTicketQueries = (
  queryClient: QueryClient,
  travellerId?: string,
) =>
  Promise.all([
    queryClient.invalidateQueries({
      queryKey: getGetTicketsForUserOrganizationQueryKey(),
    }),
    ...(travellerId
      ? [
          queryClient.invalidateQueries({
            queryKey: getGetTicketsForTravellerQueryKey(travellerId),
          }),
        ]
      : []),
  ]);

export const applyBobcatDataToTickets = (
  tickets: IssuedTicketFindResultDTO[],
  bobcatData: IssuedTicketBobcatDataMapDTO,
): IssuedTicketFindResultDTO[] =>
  tickets.map((ticket) => {
    const updated = bobcatData[ticket.id];
    if (!updated) return ticket;

    // A revoke can reach the list cache while an older bobcat response is still in flight.
    if (
      REVOKED_TICKET_STATES.has(ticket.state) &&
      !REVOKED_TICKET_STATES.has(updated.state)
    ) {
      return ticket;
    }

    return {
      ...ticket,
      state: updated.state,
      expires_at: updated.expires_at,
    };
  });
